import { render, staticRenderFns } from "./CreatePostGifButton.vue?vue&type=template&id=18a86823&"
import script from "./CreatePostGifButton.vue?vue&type=script&lang=js&"
export * from "./CreatePostGifButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports